import {createContext} from 'react'
interface InquiresPageListingContextType {
  InquiresData: any[]
  isLoading: boolean
  onPageChange: (e: number) => void
  onSearch: (searchValue: string) => void
  onSortingChange: (key: string, value: string) => void
  filters: Record<string, any>
  columns: Array<Record<string, string>> | any
  refetch: () => void
  openModal: boolean
  setOpenModal: (e: boolean) => void
  clickedId: string
  setClickedId: (e: any) => void
  Representatives: any[]
  onChangeCustomerFilter: (e: string) => void
  onChangeStatusFilter: (e: string) => void
  onChangePurchaserFilter: (e: string) => void
  onResetFilters: () => void
  hasFilterApplied: boolean

  purchasers: any[]
  isPurchasersLoading: boolean

  globalDefaultColumnsList: any
  isLoadingGlobalDefaultColumnsList: boolean
  refetchGlobalDefaultColumnsList: () => void
  updateGlobalDefaultColumnsTableSorting: (data: any) => void
  isLoadingGlobalDefaultColumnOperation: boolean
}

// Create context with default values and proper type annotations
export const InquiresPageListingContext = createContext<InquiresPageListingContextType>({
  InquiresData: [],
  isLoading: false,
  onPageChange: () => {},
  onSearch: () => {},
  onSortingChange: () => {},
  filters: {},
  columns: [], // Default to empty array
  refetch: () => {},
  openModal: false,
  setOpenModal: () => {},
  clickedId: '',
  setClickedId: () => {},
  Representatives: [],
  onChangeCustomerFilter: () => {},
  onChangeStatusFilter: () => {},
  onChangePurchaserFilter: () => {},
  onResetFilters: () => {},
  hasFilterApplied: false,

  purchasers: [],
  isPurchasersLoading: false,

  globalDefaultColumnsList: [],
  isLoadingGlobalDefaultColumnsList: false,
  refetchGlobalDefaultColumnsList: () => {},
  updateGlobalDefaultColumnsTableSorting: (data: any) => {},
  isLoadingGlobalDefaultColumnOperation: false,
})

export const SalesRepReportContext = createContext({
  salesRepData: [] as any[],
  isLoading: false,
  filters: {} as any,
  searchValue: '',
  onSearch: (value: string) => {},
  onSalesRepFilterChange: (salesRep: string) => {},
  onSortingChange: (key: string, order: string) => {},

  Representatives: [] as any[],
  RepresentativesLoading: false,
})

export const ProductReportContext = createContext({
  productData: [] as any[],
  isLoading: false,
  filters: {} as any,
  searchValue: '',
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
})

export const PurchaserReportContext = createContext({
  purchaserData: [] as any[],
  isLoading: false,
  filters: {} as any,
  searchValue: '',
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
})
